import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

export const FullBanner = styled.div<
  PropsWithChildren<{ drawerOpen: boolean }>
>`
  height: 70px;
  position: fixed;
  left: 65px;
  top: 53px;
  background-color: ${({ theme }) => theme.palette.grey['300']};
  display: flex;
  flex-direction: row;
  z-index: 11;
  box-shadow: ${({ theme }) => theme.shadows[6]};
  width: ${(props) => (props.drawerOpen ? 'calc(100% - 280px)' : '100%')};
  ${({ theme, drawerOpen }) =>
    `transition: ${theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing[drawerOpen ? 'easeOut' : 'sharp'],
      duration:
        theme.transitions.duration[
          drawerOpen ? 'enteringScreen' : 'leavingScreen'
        ],
    })}`}
`;
